module.exports = __webpack_public_path__ + "img/idme-plus.ffc060d8.svg";